/* 
 * Javier Quevedo-Fernandez
 * Copyright Ranj Games. 2013
 */

export default class BackgroundOverlayStyle {
    constructor(color, alpha, overlap) {
        this.color = color;
        this.alpha = alpha;
        this.overlap = overlap;
    }
}